import styled from "styled-components";

export const StyledExchangerWrapper = styled.div`
  width: 500px;
  padding: 15px;
  .exchanger-head {
    padding-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-light-cancel {
      width: 25px;
      height: 25px;
      font-size: 12px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover {
        background-color: ${({theme}) => theme.overlay.hover};
      }
    }
  }
  .title {
    color: ${({theme}) => theme.text.primary};
    font-size: 22px;
  }
  .exchanger-alert {
    margin: 20px 0;
  }
  
  @media screen and (max-width: 600px) {
    max-width: 320px;
    width: 100%;
    
    .title {
      font-size: 18px;
    }
  }
`;

export const StyledExchangerItem = styled.div`
  padding: 20px;
  background-color: ${({theme}) => theme.surface.hover};
  border-radius: 5px;
  
  .title {
    font-size: 14px;
  }
`;

export const StyledExchangerSelect = styled.div`
  height: 46px;
  width: 100%;
  ${({mt}) => mt && `margin-top: ${mt}px`};
  margin-bottom: 10px;
  display: grid;
  align-items: end;
`;

export const StyledExchangerInput = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  label {
    color: ${({theme}) => theme.input.labelColor};
    font-size: 14px;
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  }
  input {
    padding: 5px 0 7px;
    color: ${({theme}) => theme.input.color};
    border: none;
    background-color: transparent;
    border-bottom: 1px solid ${({theme}) => theme.overlay.underline};
    &:hover {
      border-bottom: 1px solid ${({theme}) => theme.overlay.underlineHover};
      box-shadow: 0 1px 0 0 ${({theme}) => theme.overlay.underlineHover};
    }
    &:focus {
      border-bottom: 1px solid ${({theme}) => theme.input.focusUnderline};
    }
    &::-webkit-input-placeholder {
      opacity: 0.35;
    }
    &:-moz-placeholder {
      opacity: 0.35;
    }
    &::-moz-placeholder {
      opacity: 0.35;
    }
    &:-ms-input-placeholder {
      opacity: 0.35;
    }
    &:-webkit-autofill {
      -webkit-box-shadow: inset 0 0 0 50px ${({theme}) => theme.input.autofillBackground};
    }
  }
`;

export const StyledExchangerSwap = styled.div`
  width: 35px;
  height: 35px;
  margin: 15px auto;
  font-size: 18px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 2px 4px ${({theme}) => theme.surface.shadow};
  span {
    transition: all .3s ease;
  }
  &:hover {
    span {
      transform: rotate(180deg);
    }
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const StyledExchangerActions = styled.div`
  text-align: center;
`;

export const StyledExchangerOptions = styled.div`
  padding: 6px 0 0 0;
  opacity: 0.75;
  font-size: 12px;
  span {
    color: ${({theme}) => theme.text.primary};
    font-weight: 600;

    ${({ disabled }) => !disabled && `
    cursor: pointer;
    transition: all .3s ease;
    
    &:hover {
      text-decoration: underline;
    }
  `}
  }
`;

export const StyledExchangerHistory = styled.div`
  margin: 30px 0 5px;
  color: ${({theme}) => theme.text.secondary};
  .title {
    padding-bottom: 15px;
  }
  .exchange-history-more {
    margin-top: 15px;
    text-align: center;
  }
`;

export const StyledExchangerHistoryItem = styled.div`
  padding: 10px 5px;
  ${({animation, theme}) => animation && `
    animation: updateAnimation 2.5s ease;

    @keyframes updateAnimation {
      0% {
        background-color: ${theme.badge.successBackground};
      }
      100% {
        background-color: transparent;
      }
    }
  `}
  .exchange-item-body {
    display: grid;
    grid-template-columns: 1fr 10px 1fr;
    align-items: center;
    grid-gap: 20px;
    .separator {
      text-align: center;
    }
  }
  .exchange-pair-unit {
    width: 100%;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    &__amount {
      max-width: 95%;
      padding-top: 3px;
      color: ${({theme}) => theme.text.primary};
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &:last-child {
      align-items: flex-end;
    }
  }
  .exchange-date {
    padding-top: 10px;
    text-align: center;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({theme}) => theme.surface.border};
    margin-bottom: 10px;
  }
  
  &:hover {
    color: ${({theme}) => theme.brand.primary};
    background-color: ${({theme}) => theme.surface.hover};
  }
  
 
  @media screen and (max-width: 600px) {
    .exchange-item-body {
      grid-template-columns: 100%;
      grid-gap: 10px;
      .separator {
        display: none;
      }
    }
    .exchange-pair-unit {
      align-items: flex-start !important;
    }
  }
`;